import React from 'react';
import styles from './SectionTitle.module.css';

type SectionTitleTag = 'div' | 'h1' | 'h2' | 'h3' | 'p' | 'span';

interface SectionTitleProps {
  as?: SectionTitleTag;
  children?: React.ReactNode;
  className?: string;
  spaced?: boolean;
  text?: string;
}

const SectionTitle: React.FC<SectionTitleProps> = ({
  as: Component = 'p',
  children,
  className = '',
  spaced = false,
  text,
}) => {
  const classes = [styles.title, spaced ? styles.spaced : '', className].filter(Boolean).join(' ');

  return <Component className={classes}>{text ?? children}</Component>;
};

export default SectionTitle;